import { useRef, useCallback } from 'react';

import ExploreContentCard from 'components/common/ExploreContentCard/ExploreContentCard';
import LoginPrompt from 'components/common/loginprompt/LoginPrompt';
import Modal from '@core/components/Modal/Modal';
import BackButton from '@core/components/backbutton/BackButton';

import UseToast from 'hooks/use-toast';
import UseModal from 'hooks/use-modal';

import { MOBILE_FULLSCREEN } from '@core/constants/ModalTypes';

import { Swiper, SwiperSlide } from 'swiper/react';
import ArrowRightIcon from 'assets/icons/arrow-right-gray.svg';
import ArrowLeftIcon from 'assets/icons/arrow-left-gray.svg';

import 'swiper/swiper-bundle.min.css';
import 'swiper/swiper.min.css';
import 'swiper/components/pagination/pagination.scss';

import classes from './FeaturedContent.module.scss';
import FeaturedCareerCard from './featuredcareercard/FeaturedCareerCard';

const FeaturedContent = ({ type = 'course', content }) => {
	const { toast, ToastContainer } = UseToast();
	const {
		show: loginNoticeVisible,
		showModal: loginNoticeShowModal,
		destroyModal: loginNoticeDestroyModal
	} = UseModal();

	const sliderRef = useRef(null);

	const handlePrev = useCallback(() => {
		if (!sliderRef.current) return;
		sliderRef.current.swiper.slidePrev();
	}, []);

	const handleNext = useCallback(() => {
		if (!sliderRef.current) return;
		sliderRef.current.swiper.slideNext();
	}, []);

	return (
		<>
			<div className={`${classes['explore-feature-content-wrapper']} py-5`}>
				<div className="container d-flex flex-column gap-3">
					{/* <BackButton type={'bordered'} className={'d-none d-lg-flex'} /> */}
					{/* <h3>Featured courses</h3> */}
					<div className="d-flex flex-row row">
						<div className="d-none d-lg-flex col-1 align-items-center justify-content-end">
							<button className={classes['slider-arrows-btn']} onClick={handlePrev}>
								<ArrowLeftIcon />
							</button>
						</div>
						<div className="col-12 col-lg-10">
							<Swiper
								ref={sliderRef}
								slidesPerView={1}
								spaceBetween={10}
								loop={true}
								className="mySwiper"
								style={{ height: 'auto' }}>
								{content?.map((card) => (
									<SwiperSlide style={{ height: 'auto' }}>
										{type === 'career' && (
											<FeaturedCareerCard career={card} />
										)}
										{type === 'course' && (
											<div className={`${classes['explore-feature-content-card-wrapper']} hover-shrink`}>
												<ExploreContentCard
													content={card}
													toast={toast}
													loginNoticeShowModal={loginNoticeShowModal}
													isFeatured={true}
												/>
											</div>
										)}
									</SwiperSlide>
								))}
							</Swiper>
						</div>
						<div className="d-none d-lg-flex col-1 align-items-center justify-content-start">
							<button className={classes['slider-arrows-btn']} onClick={handleNext}>
								<ArrowRightIcon />
							</button>
						</div>
					</div>
				</div>
			</div >
			<Modal
				type={MOBILE_FULLSCREEN}
				closeHandler={loginNoticeDestroyModal}
				show={loginNoticeVisible}>
				<div
					className={`${classes['login-notice-modal']} d-flex flex-column justify-content-center container`}>
					<div className={`d-flex flex-column align-items-center justify-content-center`}>
						<LoginPrompt />
					</div>
				</div>
			</Modal>
			<ToastContainer />
		</>
	);
};

export default FeaturedContent;
